// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"14378bef","488":"71f6c59c","977":"7fe4eb1c"}[chunkId] + ".chunk.js";
};